import { useMemo } from "react";

import { useAllApprovalLikelihoods } from "~/modules/project/api/approvalLikelihood/approvalLikelihoodQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { getInputDefaultOptionsData, mapDataToInputOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useApprovalLikelihoodOptions = (includeCtaOption: boolean = false): FormInputOption[] => {
	const { data: approvalLikeliHoodsData } = useAllApprovalLikelihoods();
	return useMemo(() => {
		if (approvalLikeliHoodsData) {
			const approvalLikeliHoodsDataSorted = [...approvalLikeliHoodsData].sort(byObjectProperty("percentage"));
			const options = mapDataToInputOptionsData(approvalLikeliHoodsDataSorted, "id", "displayName");

			if (includeCtaOption) {
				return [getInputDefaultOptionsData(), ...options];
			}
			return options;
		}
		return [];
	}, [approvalLikeliHoodsData, includeCtaOption]);
};

export default useApprovalLikelihoodOptions;

